
import { action } from 'typesafe-actions'

export const USER = {
    login: {
        success: 'USER_LOGIN_SUCCESS',
    },
    logout: {
        success: 'USER_LOGOUT_SUCCESS',
    },
    verify: {
        success: 'USER_VERIFY_SUCCESS',
        error: 'USER_VERIFY_ERROR',
        request: 'USER_VERIFY_REQUEST',
    },
    Profile:{
        success: 'USER_PROFILE_SUCCESS',
        error: 'USER_PROFILE_ERROR',
        request: 'USER_PROFILE_REQUEST',
        update: 'USER_PROFILE_UPDATE',
        add: 'USER_PROFILE_ADD'
    }
    // ,
    // Discount:{
    //     request: 'COURSE_DISCOUNT_REQUEST',
    //     success: 'COURSE_DISCOUNT_SUCCESS',
    //     error: 'COURSE_DISCOUNT_ERROR'
    // }
};
const userToken = 'user'; 
    
export const login = () => {
    localStorage.setItem(userToken, "true");
    return action( USER.login.success);
}
export const logout = () => {
    localStorage.removeItem(userToken);
    return action(USER.logout.success);
}
export const verify = (account:any) => {
    return action( USER.verify.request,account);
}
export const verified = () =>{
    const user = localStorage.getItem(userToken);
    if (user) {
        return action( USER.verify.success);
    }
    return action(USER.verify.error);
}

export const UpdateUserProfile = (account:any) => {
    return action( USER.Profile.update, account);
}

export const fetchUserRequest = () => {
    //console.log("fetchRequest: " + searchParams.searchTerm);
    return action(USER.Profile.request);
}

// export const getDiscountRequest = (data: any) => action(USER.Discount.request, data)
// export const getDiscountSuccess = (data: any) => action(USER.Discount.success, data)
// export const getDiscountError = (message: string) => action(USER.Discount.error, message)